module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "item",
    staticClass: "vue-grid-layout",
    style: (_vm.mergedStyle)
  }, [_vm._t("default"), _vm._v(" "), _c('grid-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDragging),
      expression: "isDragging"
    }],
    staticClass: "vue-grid-placeholder",
    attrs: {
      "x": _vm.placeholder.x,
      "y": _vm.placeholder.y,
      "w": _vm.placeholder.w,
      "h": _vm.placeholder.h,
      "i": _vm.placeholder.i
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3d4bb9a4!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/GridLayout.vue
// module id = 25
// module chunks = 0